import { atom, useAtom } from "jotai"

import type { UseReadWriteAtom } from "~/types/jotai"

export const isBufferingAtom = atom(false)
export const useIsPodcastBuffering: UseReadWriteAtom<boolean> = () =>
  useAtom(isBufferingAtom)
